/**
 * M7 S39: one comms node on the Finale screen (the asker and each roll-call voice): the speaker, the lines and the
 * replies as buttons. Every rule is in `models/finale.ts`. UI events only.
 */
import type { ReactNode } from 'react'
import type { FinaleButton, FinaleView } from './models/finale'

export interface RollCallProps {
  view: FinaleView
  row: number
  onPress: (index: number) => void
}

export function FinaleButtons(p: { buttons: readonly FinaleButton[]; row: number; onPress: (index: number) => void }): ReactNode {
  return (
    <ul className="lg-list">
      {p.buttons.map((b, i) => (
        <li key={b.id} className="lg-row" {...(p.row === i ? { 'data-focused': '' } : {})}>
          <button
            type="button"
            tabIndex={-1}
            className="sui-btn lg-btn"
            data-testid={`finale-btn-${b.id}`}
            aria-disabled={b.disabled}
            {...(p.row === i ? { 'data-focused': '' } : {})}
            onClick={() => p.onPress(i)}
          >
            {b.label}
          </button>
          {b.note === null ? null : <span className="lg-row__meta">{b.note}</span>}
        </li>
      ))}
    </ul>
  )
}

export function RollCall(p: RollCallProps): ReactNode {
  const scene = p.view.scene
  return (
    <div data-testid="finale-scene" data-node={scene?.nodeId ?? ''}>
      {p.view.heading === null ? null : <h3 className="lg-section__title">{p.view.heading}</h3>}
      {scene === null ? null : (
        <>
          <p className="lg-row__meta" data-testid="finale-speaker">
            {scene.name}
          </p>
          {scene.lines.map((line) => (
            <p key={line} className="lg-line">
              {line}
            </p>
          ))}
        </>
      )}
      <FinaleButtons buttons={p.view.buttons} row={p.row} onPress={p.onPress} />
    </div>
  )
}
